<template>
  <metainfo v-if="!notFound && !loading && !loginerforderlich">
    <title>{{ appState.sitecoreContext.item.metatitle }}</title>
    <meta name="description" :content="appState.sitecoreContext.item.metadescription" />
    <link rel="canonical" :href="appState.sitecoreContext.item.metacanonical" />
    <meta name="robots" :content="appState.sitecoreContext.item.metarobots" />
    <meta name="robots" content="max-image-preview:large" />
    <meta property="og:image" :content="appState.sitecoreContext.item.opengraphbild" />
    <meta
      v-if="appState.sitecoreContext.item.opengraphtitel"
      property="og:title"
      :content="appState.sitecoreContext.item.opengraphtitel"
    />
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width" />
  </metainfo>

  <not-found v-if="notFound && !loading" />
  <route-loading v-else-if="loading" />
  <login v-else-if="loginerforderlich" :context="appState.sitecoreContext" />
  <component
    v-else
    :is="getLayout()"
    :route="appState.routeData"
    :context="appState.sitecoreContext"
  />
</template>

<script>
import { layoutServiceFactory } from './lib/layout-service-factory';

import NotFound from './NotFound';
import RouteLoading from './RouteLoading';
import Login from './Login';
import LayoutHerder from './layouts/LayoutHerder.vue';
import LayoutBM from './layouts/LayoutBM.vue';
import LayoutMicrosite from './layouts/LayoutMicrosite.vue';

export default {
  name: 'Route-Handler',
  data() {
    const state = {
      notFound: true,
      loading: true,
      loginerforderlich: true,
      layoutId: '',
    };
    const appState = this.$jss.store.state;

    if (appState.routeData) {
      state.loading = false;
      state.loginerforderlich = appState.sitecoreContext.loginerforderlich;
      state.layoutId = appState.routeData.layoutId.toUpperCase();
    }
    if (this.route !== null) {
      state.notFound = false;
    }
    if (!appState.routeData) {
      state.notFound = true;
    }

    return { ...state, appState };
  },
  props: {
    route: {
      type: Object,
    },
  },
  created() {
    if (!this.appState.routeData) {
      this.updateRouteData();
    }
  },
  methods: {
    updateRouteData() {
      let sitecoreRoutePath = this.route.params.sitecoreRoute
        ? this.route.params.sitecoreRoute.join('/')
        : '/';
      if (!sitecoreRoutePath.startsWith('/')) {
        sitecoreRoutePath = `/${sitecoreRoutePath}`;
      }

      this.loading = true;

      const layoutServiceInstance = layoutServiceFactory.create();
      layoutServiceInstance.fetchLayoutData(sitecoreRoutePath).then((routeData) => {
        if (routeData !== null && routeData.sitecore.route) {
          this.$jss.store.setSitecoreData(routeData);
          this.loginerforderlich = routeData.sitecore.context.loginerforderlich;
          this.layoutId = routeData.sitecore.route.layoutId.toUpperCase();
          this.notFound = false;
        } else {
          this.$jss.store.setSitecoreData(routeData);
          this.notFound = true;
        }

        this.loading = false;
      });
    },
    getLayout() {
      if (this.layoutId == '1827AF50-AC77-43C9-9506-459A48148C2D') return LayoutHerder;
      else if (this.layoutId == '0BE2BCEF-4A16-4C05-A93F-759D1213B207') return LayoutBM;
      else if (this.layoutId == 'DD4BF759-D456-49CA-BE1D-FB5E2C5599F0') return LayoutMicrosite;
    },
  },
  watch: {
    route(newRoute, oldRoute) {
      if (newRoute.hash !== '' && newRoute.path === oldRoute.path) {
        return;
      }
      this.updateRouteData();
    },
  },
  components: {
    NotFound,
    RouteLoading,
    Login,
  },
};
</script>
